import LanguageIcon from "@mui/icons-material/Language";
import {
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "pt-BR", label: "Português", flag: "🇧🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
] as const;

const STORAGE_KEY = "smartdocs-signer-language";

export default function LanguageSwitcher(): React.JSX.Element {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleChange = (code: string): void => {
    void i18n.changeLanguage(code);
    localStorage.setItem(STORAGE_KEY, code);
    handleClose();
  };

  return (
    <>
      <Tooltip title={t("language.label")}>
        <IconButton
          color="primary"
          id="language-switcher-btn"
          onClick={handleOpen}
          sx={{ fontSize: "1.2rem" }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        id="language-menu"
        onClose={handleClose}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => {
              handleChange(lang.code);
            }}
            selected={i18n.language === lang.code}
          >
            <ListItemText>
              {lang.flag} {lang.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
